export const directionOfAnimation = (valuePanel, prevValuePanel) => {
  if (Number(valuePanel) < Number(prevValuePanel)) return 'animate__animated animate__fadeIn'
  if (Number(valuePanel) > Number(prevValuePanel)) return 'animate__animated animate__fadeIn'
}
